import React                              from 'react';
import { Observe }                        from 'rewire-core';
import {
  WithStyle,
  FormView,
}                                         from 'rewire-ui';
import { Theme }                          from '@material-ui/core/styles';
import DraggableResizableDialog           from '../ui/DraggableResizableDialog';
import updateJobEffectiveRangeDialogModel from './UpdateJobEffectiveRangeDialogModel';
import { withStyles }                     from '../utility/styles';

const styles = (_theme: Theme) => ({
});

interface IUpdateJobEffectiveRangeDialogProps {
}

type UpdateJobEffectiveRangeDialogProps = WithStyle<ReturnType<typeof styles>, IUpdateJobEffectiveRangeDialogProps>;

class UpdateJobEffectiveRangeDialog extends React.PureComponent<UpdateJobEffectiveRangeDialogProps> {
  constructor(props: UpdateJobEffectiveRangeDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    updateJobEffectiveRangeDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    // const {classes} = this.props;

    return <Observe render={() => (
      <FormView form={updateJobEffectiveRangeDialogModel.form} onSubmit={updateJobEffectiveRangeDialogModel.actionFn('save')}>
        <div className={'content'}>
          <updateJobEffectiveRangeDialogModel.form.field.startDate.Editor />
          <updateJobEffectiveRangeDialogModel.form.field.endDate.Editor />
        </div>
        <div className={'content'}>
          <updateJobEffectiveRangeDialogModel.form.field.removeOverlappingAssignments.Editor />
        </div>
     </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: updateJobEffectiveRangeDialogModel}} DraggableResizableBoxProps={{minWidth: '275px', minHeight: '258px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IUpdateJobEffectiveRangeDialogProps>(styles, UpdateJobEffectiveRangeDialog);
